module.exports = __webpack_public_path__ + "static/3A841E_4_0-9a66f6d6161752f3ef3b4f2bb1f9e223.ttf";